import React from 'react';
import {camelCase, flatten, includes, snakeCase, split} from "lodash";


export function hasAgentPower(agent, ...powersWanted) {
  let myPowers = normalizePowersList(agent.powers);
  powersWanted = normalizePowersList(powersWanted);

  console.log(`COMPARE POWER: ${JSON.stringify(powersWanted)} in ${JSON.stringify(myPowers)}`);

  for (let pow of powersWanted) {
    if (includes(myPowers, pow))
      return true;

    if (camelCase(agent.username) === pow)
      return true;
  }

  return includes(myPowers, 'super');
}

export function hasTeamLeadPowers(agent) {
  return hasAgentPower(agent, "teamLead topAgent specialAgent");
}



/*
 * Given an array of power names, or a space-separated string of power names,
 * convert to camelcase and return as array.
 *
 */
export function normalizePowersList(powers) {
  if (Array.isArray(powers)) {
    return flatten( flatten(powers).map( p => normalizePowersList(p) ));
  }

  return split(powers || "", ' ').map( p => camelCase(p));
}
